import { t } from 'i18next';
import { call, put, select, takeLatest } from 'redux-saga/effects';
import { appDanger, appSuccess } from '../app_alerts/slice';
import { getOrganizationSlug } from '../organizations/selectors';
import { getContacts, patchExistingContact, postNewContact, removeContact } from './data';
import { errorReceiveContacts, errorReceiveCreateContact, errorReceiveModifyContact, errorReceiveRemoveContact, failedReceiveContacts, failedReceiveCreateContact, failedReceiveModifyContact, failedReceiveRemoveContact, receiveContacts, receiveCreateContact, receiveModifyContact, receiveRemoveContact } from './slice';
export function* requestContacts(action) {
    try {
        const { consumerAPI } = action.payload;
        const organization = yield select(getOrganizationSlug);
        const response = yield call(getContacts, organization, consumerAPI);
        if (!consumerAPI) {
            const { data, error } = response;
            if (error) {
                yield put(errorReceiveContacts());
            }
            else if (data) {
                yield put(receiveContacts(data));
            }
            else {
                throw new Error(t('FAILED_REQUEST_CONTACTS', {
                    ns: 'Common'
                }));
            }
        }
        else {
            if (response && response.status !== 200) {
                yield put(errorReceiveContacts());
            }
            else if (response && response.status === 200) {
                yield put(receiveContacts(response.data));
            }
            else {
                throw new Error(t('FAILED_REQUEST_CONTACTS', {
                    ns: 'Common'
                }));
            }
        }
    }
    catch (e) {
        yield put(failedReceiveContacts());
    }
}
export function* requestCreateContact(action) {
    try {
        const { consumerAPI, contactPayload } = action.payload;
        const organization = yield select(getOrganizationSlug);
        const response = yield call(postNewContact, organization, contactPayload, consumerAPI);
        if (!consumerAPI) {
            const { data, error } = response;
            if (error) {
                yield put(errorReceiveCreateContact());
                yield put(appDanger(t('ERROR_REQUEST_CREATE_CONTACT', {
                    ns: 'Common'
                })));
            }
            else if (data) {
                yield put(receiveCreateContact(data));
                yield put(appSuccess(t('SUCCESS_REQUEST_CREATE_CONTACT', {
                    ns: 'Common'
                })));
            }
            else {
                throw new Error(t('FAILED_REQUEST_CREATE_CONTACT', {
                    ns: 'Common'
                }));
            }
        }
        else {
            if (response && response.status !== 200) {
                yield put(errorReceiveCreateContact());
                yield put(appDanger(t('ERROR_REQUEST_CREATE_CONTACT', {
                    ns: 'Common'
                })));
            }
            else if (response && response.status === 200) {
                yield put(receiveCreateContact(response.data));
                yield put(appSuccess(t('SUCCESS_REQUEST_CREATE_CONTACT', {
                    ns: 'Common'
                })));
            }
            else {
                throw new Error(t('FAILED_REQUEST_CREATE_CONTACT', {
                    ns: 'Common'
                }));
            }
        }
    }
    catch (e) {
        yield put(failedReceiveCreateContact());
    }
}
export function* requestModifyContact(action) {
    try {
        const { consumerAPI, contactId, contactPayload } = action.payload;
        const organization = yield select(getOrganizationSlug);
        const response = yield call(patchExistingContact, organization, contactId, contactPayload, consumerAPI);
        if (!consumerAPI) {
            const { data, error } = response;
            if (error) {
                yield put(errorReceiveModifyContact());
                yield put(appDanger(t('ERROR_REQUEST_MODIFY_CONTACT', {
                    ns: 'Common'
                })));
            }
            else if (data) {
                yield put(receiveModifyContact(data));
                yield put(appSuccess(t('SUCCESS_REQUEST_MODIFY_CONTACT', {
                    ns: 'Common'
                })));
            }
            else {
                throw new Error(t('FAILED_REQUEST_MODIFY_CONTACT', {
                    ns: 'Common'
                }));
            }
        }
        else {
            if (response && response.status !== 200) {
                yield put(errorReceiveModifyContact());
                yield put(appDanger(t('ERROR_REQUEST_MODIFY_CONTACT', {
                    ns: 'Common'
                })));
            }
            else if (response && response.status === 200) {
                yield put(receiveModifyContact(response.data, consumerAPI));
                yield put(appSuccess(t('SUCCESS_REQUEST_MODIFY_CONTACT', {
                    ns: 'Common'
                })));
            }
            else {
                throw new Error(t('FAILED_REQUEST_MODIFY_CONTACT', {
                    ns: 'Common'
                }));
            }
        }
    }
    catch (e) {
        yield put(failedReceiveModifyContact());
    }
}
export function* requestRemoveContact(action) {
    try {
        const { consumerAPI, contactId } = action.payload;
        const organization = yield select(getOrganizationSlug);
        const response = yield call(removeContact, organization, contactId, consumerAPI);
        if (!consumerAPI) {
            const { data, error } = response;
            if (error) {
                yield put(errorReceiveRemoveContact());
                yield put(appDanger(t('ERROR_REQUEST_REMOVE_CONTACT', {
                    ns: 'Common'
                })));
            }
            else if (data) {
                yield put(receiveRemoveContact(data));
                yield put(appSuccess(t('SUCCESS_REQUEST_REMOVE_CONTACT', {
                    ns: 'Common'
                })));
            }
            else {
                throw new Error(t('FAILED_REQUEST_REMOVE_CONTACT', {
                    ns: 'Common'
                }));
            }
        }
        else {
            if (response && response.status !== 204) {
                yield put(errorReceiveRemoveContact());
                yield put(appDanger(t('ERROR_REQUEST_REMOVE_CONTACT', {
                    ns: 'Common'
                })));
            }
            else if (response && response.status === 204) {
                yield put(receiveRemoveContact(contactId, consumerAPI));
                yield put(appSuccess(t('SUCCESS_REQUEST_REMOVE_CONTACT', {
                    ns: 'Common'
                })));
            }
            else {
                throw new Error(t('FAILED_REQUEST_REMOVE_CONTACT', {
                    ns: 'Common'
                }));
            }
        }
    }
    catch (e) {
        yield put(failedReceiveRemoveContact());
    }
}
export function* watchRequestContacts() {
    yield takeLatest('contacts/requestContacts', requestContacts);
}
export function* watchRequestCreateContact() {
    yield takeLatest('contacts/requestCreateContact', requestCreateContact);
}
export function* watchRequestModifyContact() {
    yield takeLatest('contacts/requestModifyContact', requestModifyContact);
}
export function* watchRequestRemoveContact() {
    yield takeLatest('contacts/requestRemoveContact', requestRemoveContact);
}
